export const AUDIO_FEEL_CONFIG = {
  // ── Master ────────────────────────────────────────────────────────────────
  masterVolumeDb: -16,

  // ── Music Track ───────────────────────────────────────────────────────────
  // Set this to the final master file once it is ready.
  // Until then the fallback silence placeholder keeps the AudioContext open.
  musicUrl: "/assets/audio/run-campeon-master.mp3",
  musicLoop: true,
  musicVolumeDb: -6,
  musicSilentDb: -48,
  songEnergyStart: 0.72,
  songEnergyDrainPerSecond: 0.0118,
  songEnergyPickupRestore: 0.25,
  songEnergyAudibleThreshold: 0.04,
  songEnergyCriticalThreshold: 0.25,
  songEnergyScorePerSecond: 165,
  songEnergyFinishThreshold: 0.22,
  songEnergyFinishBonus: 8500,

  // ── Wolf Breath ───────────────────────────────────────────────────────────
  wolfBreathMinDb: -42,
  wolfBreathMaxDb: -27,
  wolfBreathFilterMin: 180,
  wolfBreathFilterMax: 720,

  // ── Danger Drone ─────────────────────────────────────────────────────────
  dangerDroneMinDb: -44,
  dangerDroneMaxDb: -21,
  dangerDroneBaseHz: 42,
  dangerDroneMaxHz: 76,

  // ── Heartbeat ─────────────────────────────────────────────────────────────
  heartbeatThreshold: 0.34,
  heartbeatMinInterval: 0.28,
  heartbeatMaxInterval: 0.82,
  heartbeatVolumeDb: -18,

  // ── Footsteps ─────────────────────────────────────────────────────────────
  footstepMinSpeed: 85,
  footstepInterval: 0.13,
  footstepVolumeDb: -29,

  // ── Pickups ───────────────────────────────────────────────────────────────
  pickupVolumeDb: -14,
  pickupNotes: ["E5", "B5", "D#6"],

  // ── Stingers ─────────────────────────────────────────────────────────────
  championChargeVolumeDb: -20,
  loseVolumeDb: -12,
  winVolumeDb: -12
} as const;
